export const homePageMode = {
  cases: 'CASES',
  templates: 'TEMPLATES',
};
